import { BASE_PATH as v, BaseAPI as x, operationServerMap as b } from "../base.js";
import { DUMMY_BASE_URL as M, assertParamExists as I, createRequestFunction as u, serializeDataIfNeeded as A, setSearchParams as O, toPathString as V } from "../common.js";
import C from "axios";
var w = function(a) {
  return {
    adminControlledMemberImportConfirm: async (n, o, d = {}) => {
      I("adminControlledMemberImportConfirm", "importBatchId", n), I("adminControlledMemberImportConfirm", "memberImportConfirmRequest", o);
      const t = "/admin/members/import-batches/{importBatchId}/confirm".replace("{importBatchId}", encodeURIComponent(String(n))), r = new URL(t, M);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "POST",
        ...e,
        ...d
      }, m = {}, l = {};
      m["Content-Type"] = "application/json", O(r, l);
      let i = e && e.headers ? e.headers : {};
      return s.headers = {
        ...m,
        ...i,
        ...d.headers
      }, s.data = A(o, s, a), {
        url: V(r),
        options: s
      };
    },
    adminControlledMemberImportErrors: async (n, o = {}) => {
      I("adminControlledMemberImportErrors", "importBatchId", n);
      const d = "/admin/members/import-batches/{importBatchId}/errors".replace("{importBatchId}", encodeURIComponent(String(n))), t = new URL(d, M);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "GET",
        ...r,
        ...o
      }, s = {};
      O(t, {});
      let m = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...m,
        ...o.headers
      }, {
        url: V(t),
        options: e
      };
    },
    adminControlledMemberImportGet: async (n, o = {}) => {
      I("adminControlledMemberImportGet", "importBatchId", n);
      const d = "/admin/members/import-batches/{importBatchId}".replace("{importBatchId}", encodeURIComponent(String(n))), t = new URL(d, M);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "GET",
        ...r,
        ...o
      }, s = {};
      O(t, {});
      let m = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...m,
        ...o.headers
      }, {
        url: V(t),
        options: e
      };
    },
    adminControlledMemberImportList: async (n, o, d = {}) => {
      const t = new URL("/admin/members/import-batches", M);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "GET",
        ...r,
        ...d
      }, s = {}, m = {};
      n !== void 0 && (m.page = n), o !== void 0 && (m.pageSize = o), O(t, m);
      let l = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...l,
        ...d.headers
      }, {
        url: V(t),
        options: e
      };
    },
    adminControlledMemberImportPreview: async (n, o = {}) => {
      I("adminControlledMemberImportPreview", "controlledMemberImportPreviewRequest", n);
      const d = new URL("/admin/members/import-batches/previews", M);
      let t;
      a && (t = a.baseOptions);
      const r = {
        method: "POST",
        ...t,
        ...o
      }, e = {}, s = {};
      e["Content-Type"] = "application/json", O(d, s);
      let m = t && t.headers ? t.headers : {};
      return r.headers = {
        ...e,
        ...m,
        ...o.headers
      }, r.data = A(n, r, a), {
        url: V(d),
        options: r
      };
    },
    adminControlledMemberImportSourceLevels: async (n, o = {}) => {
      I("adminControlledMemberImportSourceLevels", "sourceShopId", n);
      const d = "/admin/members/import-batches/source-shops/{sourceShopId}/levels".replace("{sourceShopId}", encodeURIComponent(String(n))), t = new URL(d, M);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "GET",
        ...r,
        ...o
      }, s = {};
      O(t, {});
      let m = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...m,
        ...o.headers
      }, {
        url: V(t),
        options: e
      };
    },
    adminLegacyMemberImportCreateLegacyImportTask: async (n, o, d = {}) => {
      const t = new URL("/admin/members/legacy-import/tasks", M);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...d
      }, s = {}, m = {};
      n !== void 0 && (m.dryRun = n), o !== void 0 && (m.brandId = o), O(t, m);
      let l = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...l,
        ...d.headers
      }, {
        url: V(t),
        options: e
      };
    },
    adminLegacyMemberImportGetLegacyImportTask: async (n, o = {}) => {
      I("adminLegacyMemberImportGetLegacyImportTask", "taskId", n);
      const d = "/admin/members/legacy-import/tasks/{taskId}".replace("{taskId}", encodeURIComponent(String(n))), t = new URL(d, M);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "GET",
        ...r,
        ...o
      }, s = {};
      O(t, {});
      let m = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...m,
        ...o.headers
      }, {
        url: V(t),
        options: e
      };
    },
    adminLegacyMemberImportLegacyImport: async (n, o, d = {}) => {
      const t = new URL("/admin/members/legacy-import", M);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...d
      }, s = {}, m = {};
      n !== void 0 && (m.dryRun = n), o !== void 0 && (m.brandId = o), O(t, m);
      let l = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...l,
        ...d.headers
      }, {
        url: V(t),
        options: e
      };
    },
    adminLegacyMemberImportLegacyImportTaskEvents: async (n, o = {}) => {
      I("adminLegacyMemberImportLegacyImportTaskEvents", "taskId", n);
      const d = "/admin/members/legacy-import/tasks/{taskId}/events".replace("{taskId}", encodeURIComponent(String(n))), t = new URL(d, M);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "GET",
        ...r,
        ...o
      }, s = {};
      O(t, {});
      let m = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...m,
        ...o.headers
      }, {
        url: V(t),
        options: e
      };
    },
    adminMemberAssets: async (n, o, d = {}) => {
      I("adminMemberAssets", "merchantCustomerUserId", n);
      const t = "/admin/members/{merchantCustomerUserId}/assets".replace("{merchantCustomerUserId}", encodeURIComponent(String(n))), r = new URL(t, M);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...d
      }, m = {}, l = {};
      o !== void 0 && (l.shopId = o), O(r, l);
      let i = e && e.headers ? e.headers : {};
      return s.headers = {
        ...m,
        ...i,
        ...d.headers
      }, {
        url: V(r),
        options: s
      };
    },
    adminMemberCashbackRecords: async (n, o, d, t, r = {}) => {
      I("adminMemberCashbackRecords", "merchantCustomerUserId", n);
      const e = "/admin/members/{merchantCustomerUserId}/records/cashback".replace("{merchantCustomerUserId}", encodeURIComponent(String(n))), s = new URL(e, M);
      let m;
      a && (m = a.baseOptions);
      const l = {
        method: "GET",
        ...m,
        ...r
      }, i = {}, c = {};
      o !== void 0 && (c.page = o), d !== void 0 && (c.pageSize = d), t !== void 0 && (c.shopId = t), O(s, c);
      let p = m && m.headers ? m.headers : {};
      return l.headers = {
        ...i,
        ...p,
        ...r.headers
      }, {
        url: V(s),
        options: l
      };
    },
    adminMemberCreate: async (n, o, d = {}) => {
      I("adminMemberCreate", "adminMemberCreateRequestDTO", n);
      const t = new URL("/admin/members", M);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...d
      }, s = {}, m = {};
      o !== void 0 && (m.shopId = o), s["Content-Type"] = "application/json", O(t, m);
      let l = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...l,
        ...d.headers
      }, e.data = A(n, e, a), {
        url: V(t),
        options: e
      };
    },
    adminMemberDelete: async (n, o, d = {}) => {
      I("adminMemberDelete", "merchantCustomerUserId", n);
      const t = "/admin/members/{merchantCustomerUserId}".replace("{merchantCustomerUserId}", encodeURIComponent(String(n))), r = new URL(t, M);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "DELETE",
        ...e,
        ...d
      }, m = {}, l = {};
      o !== void 0 && (l.shopId = o), O(r, l);
      let i = e && e.headers ? e.headers : {};
      return s.headers = {
        ...m,
        ...i,
        ...d.headers
      }, {
        url: V(r),
        options: s
      };
    },
    adminMemberDetail: async (n, o, d = {}) => {
      I("adminMemberDetail", "merchantCustomerUserId", n);
      const t = "/admin/members/{merchantCustomerUserId}".replace("{merchantCustomerUserId}", encodeURIComponent(String(n))), r = new URL(t, M);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...d
      }, m = {}, l = {};
      o !== void 0 && (l.shopId = o), O(r, l);
      let i = e && e.headers ? e.headers : {};
      return s.headers = {
        ...m,
        ...i,
        ...d.headers
      }, {
        url: V(r),
        options: s
      };
    },
    adminMemberDuplicates: async (n, o, d, t = {}) => {
      const r = new URL("/admin/members/duplicates", M);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...t
      }, m = {}, l = {};
      n !== void 0 && (l.page = n), o !== void 0 && (l.pageSize = o), d !== void 0 && (l.phone = d), O(r, l);
      let i = e && e.headers ? e.headers : {};
      return s.headers = {
        ...m,
        ...i,
        ...t.headers
      }, {
        url: V(r),
        options: s
      };
    },
    adminMemberGrowthPointRecords: async (n, o, d, t, r = {}) => {
      I("adminMemberGrowthPointRecords", "merchantCustomerUserId", n);
      const e = "/admin/members/{merchantCustomerUserId}/records/growth-points".replace("{merchantCustomerUserId}", encodeURIComponent(String(n))), s = new URL(e, M);
      let m;
      a && (m = a.baseOptions);
      const l = {
        method: "GET",
        ...m,
        ...r
      }, i = {}, c = {};
      o !== void 0 && (c.page = o), d !== void 0 && (c.pageSize = d), t !== void 0 && (c.shopId = t), O(s, c);
      let p = m && m.headers ? m.headers : {};
      return l.headers = {
        ...i,
        ...p,
        ...r.headers
      }, {
        url: V(s),
        options: l
      };
    },
    adminMemberLevelOptions: async (n, o, d = {}) => {
      I("adminMemberLevelOptions", "merchantCustomerUserId", n);
      const t = "/admin/members/{merchantCustomerUserId}/level-options".replace("{merchantCustomerUserId}", encodeURIComponent(String(n))), r = new URL(t, M);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...d
      }, m = {}, l = {};
      o !== void 0 && (l.shopId = o), O(r, l);
      let i = e && e.headers ? e.headers : {};
      return s.headers = {
        ...m,
        ...i,
        ...d.headers
      }, {
        url: V(r),
        options: s
      };
    },
    adminMemberList: async (n, o, d = {}) => {
      I("adminMemberList", "query", n);
      const t = new URL("/admin/members", M);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "GET",
        ...r,
        ...d
      }, s = {}, m = {};
      if (n !== void 0) for (const [i, c] of Object.entries(n)) m[i] = c;
      o !== void 0 && (m.shopId = o), O(t, m);
      let l = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...l,
        ...d.headers
      }, {
        url: V(t),
        options: e
      };
    },
    adminMemberMerge: async (n, o, d = {}) => {
      I("adminMemberMerge", "primaryId", n), I("adminMemberMerge", "memberMergeRequest", o);
      const t = "/admin/members/{primaryId}/merge".replace("{primaryId}", encodeURIComponent(String(n))), r = new URL(t, M);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "POST",
        ...e,
        ...d
      }, m = {}, l = {};
      m["Content-Type"] = "application/json", O(r, l);
      let i = e && e.headers ? e.headers : {};
      return s.headers = {
        ...m,
        ...i,
        ...d.headers
      }, s.data = A(o, s, a), {
        url: V(r),
        options: s
      };
    },
    adminMemberPointEvents: async (n, o, d, t, r, e, s, m, l = {}) => {
      I("adminMemberPointEvents", "merchantCustomerUserId", n);
      const i = "/admin/members/{merchantCustomerUserId}/records/point-events".replace("{merchantCustomerUserId}", encodeURIComponent(String(n))), c = new URL(i, M);
      let p;
      a && (p = a.baseOptions);
      const S = {
        method: "GET",
        ...p,
        ...l
      }, U = {}, y = {};
      o !== void 0 && (y.page = o), d !== void 0 && (y.pageSize = d), t !== void 0 && (y.shopId = t), r !== void 0 && (y.category = r), e !== void 0 && (y.orderId = e), s !== void 0 && (y.startAt = s instanceof Date ? s.toISOString() : s), m !== void 0 && (y.endAt = m instanceof Date ? m.toISOString() : m), O(c, y);
      let L = p && p.headers ? p.headers : {};
      return S.headers = {
        ...U,
        ...L,
        ...l.headers
      }, {
        url: V(c),
        options: S
      };
    },
    adminMemberPointRecords: async (n, o, d, t, r, e, s, m, l = {}) => {
      I("adminMemberPointRecords", "merchantCustomerUserId", n);
      const i = "/admin/members/{merchantCustomerUserId}/records/points".replace("{merchantCustomerUserId}", encodeURIComponent(String(n))), c = new URL(i, M);
      let p;
      a && (p = a.baseOptions);
      const S = {
        method: "GET",
        ...p,
        ...l
      }, U = {}, y = {};
      o !== void 0 && (y.page = o), d !== void 0 && (y.pageSize = d), t !== void 0 && (y.shopId = t), r !== void 0 && (y.channel = r), e !== void 0 && (y.transactionType = e), s !== void 0 && (y.startAt = s instanceof Date ? s.toISOString() : s), m !== void 0 && (y.endAt = m instanceof Date ? m.toISOString() : m), O(c, y);
      let L = p && p.headers ? p.headers : {};
      return S.headers = {
        ...U,
        ...L,
        ...l.headers
      }, {
        url: V(c),
        options: S
      };
    },
    adminMemberStats: async (n = {}) => {
      const o = new URL("/admin/members/stats", M);
      let d;
      a && (d = a.baseOptions);
      const t = {
        method: "GET",
        ...d,
        ...n
      }, r = {};
      O(o, {});
      let e = d && d.headers ? d.headers : {};
      return t.headers = {
        ...r,
        ...e,
        ...n.headers
      }, {
        url: V(o),
        options: t
      };
    },
    adminMemberUpdateLevel: async (n, o, d, t = {}) => {
      I("adminMemberUpdateLevel", "merchantCustomerUserId", n), I("adminMemberUpdateLevel", "adminMemberLevelUpdateRequestDTO", o);
      const r = "/admin/members/{merchantCustomerUserId}/level".replace("{merchantCustomerUserId}", encodeURIComponent(String(n))), e = new URL(r, M);
      let s;
      a && (s = a.baseOptions);
      const m = {
        method: "PUT",
        ...s,
        ...t
      }, l = {}, i = {};
      d !== void 0 && (i.shopId = d), l["Content-Type"] = "application/json", O(e, i);
      let c = s && s.headers ? s.headers : {};
      return m.headers = {
        ...l,
        ...c,
        ...t.headers
      }, m.data = A(o, m, a), {
        url: V(e),
        options: m
      };
    },
    adminMemberUpdateMember: async (n, o, d, t = {}) => {
      I("adminMemberUpdateMember", "merchantCustomerUserId", n), I("adminMemberUpdateMember", "adminMemberUpdateRequestDTO", o);
      const r = "/admin/members/{merchantCustomerUserId}".replace("{merchantCustomerUserId}", encodeURIComponent(String(n))), e = new URL(r, M);
      let s;
      a && (s = a.baseOptions);
      const m = {
        method: "PUT",
        ...s,
        ...t
      }, l = {}, i = {};
      d !== void 0 && (i.shopId = d), l["Content-Type"] = "application/json", O(e, i);
      let c = s && s.headers ? s.headers : {};
      return m.headers = {
        ...l,
        ...c,
        ...t.headers
      }, m.data = A(o, m, a), {
        url: V(e),
        options: m
      };
    },
    adminMemberUpdateStatus: async (n, o, d, t = {}) => {
      I("adminMemberUpdateStatus", "merchantCustomerUserId", n), I("adminMemberUpdateStatus", "adminMemberStatusUpdateRequestDTO", o);
      const r = "/admin/members/{merchantCustomerUserId}/status".replace("{merchantCustomerUserId}", encodeURIComponent(String(n))), e = new URL(r, M);
      let s;
      a && (s = a.baseOptions);
      const m = {
        method: "PATCH",
        ...s,
        ...t
      }, l = {}, i = {};
      d !== void 0 && (i.shopId = d), l["Content-Type"] = "application/json", O(e, i);
      let c = s && s.headers ? s.headers : {};
      return m.headers = {
        ...l,
        ...c,
        ...t.headers
      }, m.data = A(o, m, a), {
        url: V(e),
        options: m
      };
    }
  };
}, h = function(a) {
  const n = w(a);
  return {
    async adminControlledMemberImportConfirm(o, d, t) {
      var r, e;
      const s = await n.adminControlledMemberImportConfirm(o, d, t), m = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = b["MemberAdminApi.adminControlledMemberImportConfirm"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => u(s, C, v, a)(i, l || c);
    },
    async adminControlledMemberImportErrors(o, d) {
      var t, r;
      const e = await n.adminControlledMemberImportErrors(o, d), s = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, m = (r = b["MemberAdminApi.adminControlledMemberImportErrors"]) === null || r === void 0 || (r = r[s]) === null || r === void 0 ? void 0 : r.url;
      return (l, i) => u(e, C, v, a)(l, m || i);
    },
    async adminControlledMemberImportGet(o, d) {
      var t, r;
      const e = await n.adminControlledMemberImportGet(o, d), s = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, m = (r = b["MemberAdminApi.adminControlledMemberImportGet"]) === null || r === void 0 || (r = r[s]) === null || r === void 0 ? void 0 : r.url;
      return (l, i) => u(e, C, v, a)(l, m || i);
    },
    async adminControlledMemberImportList(o, d, t) {
      var r, e;
      const s = await n.adminControlledMemberImportList(o, d, t), m = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = b["MemberAdminApi.adminControlledMemberImportList"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => u(s, C, v, a)(i, l || c);
    },
    async adminControlledMemberImportPreview(o, d) {
      var t, r;
      const e = await n.adminControlledMemberImportPreview(o, d), s = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, m = (r = b["MemberAdminApi.adminControlledMemberImportPreview"]) === null || r === void 0 || (r = r[s]) === null || r === void 0 ? void 0 : r.url;
      return (l, i) => u(e, C, v, a)(l, m || i);
    },
    async adminControlledMemberImportSourceLevels(o, d) {
      var t, r;
      const e = await n.adminControlledMemberImportSourceLevels(o, d), s = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, m = (r = b["MemberAdminApi.adminControlledMemberImportSourceLevels"]) === null || r === void 0 || (r = r[s]) === null || r === void 0 ? void 0 : r.url;
      return (l, i) => u(e, C, v, a)(l, m || i);
    },
    async adminLegacyMemberImportCreateLegacyImportTask(o, d, t) {
      var r, e;
      const s = await n.adminLegacyMemberImportCreateLegacyImportTask(o, d, t), m = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = b["MemberAdminApi.adminLegacyMemberImportCreateLegacyImportTask"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => u(s, C, v, a)(i, l || c);
    },
    async adminLegacyMemberImportGetLegacyImportTask(o, d) {
      var t, r;
      const e = await n.adminLegacyMemberImportGetLegacyImportTask(o, d), s = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, m = (r = b["MemberAdminApi.adminLegacyMemberImportGetLegacyImportTask"]) === null || r === void 0 || (r = r[s]) === null || r === void 0 ? void 0 : r.url;
      return (l, i) => u(e, C, v, a)(l, m || i);
    },
    async adminLegacyMemberImportLegacyImport(o, d, t) {
      var r, e;
      const s = await n.adminLegacyMemberImportLegacyImport(o, d, t), m = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = b["MemberAdminApi.adminLegacyMemberImportLegacyImport"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => u(s, C, v, a)(i, l || c);
    },
    async adminLegacyMemberImportLegacyImportTaskEvents(o, d) {
      var t, r;
      const e = await n.adminLegacyMemberImportLegacyImportTaskEvents(o, d), s = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, m = (r = b["MemberAdminApi.adminLegacyMemberImportLegacyImportTaskEvents"]) === null || r === void 0 || (r = r[s]) === null || r === void 0 ? void 0 : r.url;
      return (l, i) => u(e, C, v, a)(l, m || i);
    },
    async adminMemberAssets(o, d, t) {
      var r, e;
      const s = await n.adminMemberAssets(o, d, t), m = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = b["MemberAdminApi.adminMemberAssets"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => u(s, C, v, a)(i, l || c);
    },
    async adminMemberCashbackRecords(o, d, t, r, e) {
      var s, m;
      const l = await n.adminMemberCashbackRecords(o, d, t, r, e), i = (s = a == null ? void 0 : a.serverIndex) !== null && s !== void 0 ? s : 0, c = (m = b["MemberAdminApi.adminMemberCashbackRecords"]) === null || m === void 0 || (m = m[i]) === null || m === void 0 ? void 0 : m.url;
      return (p, S) => u(l, C, v, a)(p, c || S);
    },
    async adminMemberCreate(o, d, t) {
      var r, e;
      const s = await n.adminMemberCreate(o, d, t), m = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = b["MemberAdminApi.adminMemberCreate"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => u(s, C, v, a)(i, l || c);
    },
    async adminMemberDelete(o, d, t) {
      var r, e;
      const s = await n.adminMemberDelete(o, d, t), m = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = b["MemberAdminApi.adminMemberDelete"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => u(s, C, v, a)(i, l || c);
    },
    async adminMemberDetail(o, d, t) {
      var r, e;
      const s = await n.adminMemberDetail(o, d, t), m = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = b["MemberAdminApi.adminMemberDetail"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => u(s, C, v, a)(i, l || c);
    },
    async adminMemberDuplicates(o, d, t, r) {
      var e, s;
      const m = await n.adminMemberDuplicates(o, d, t, r), l = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, i = (s = b["MemberAdminApi.adminMemberDuplicates"]) === null || s === void 0 || (s = s[l]) === null || s === void 0 ? void 0 : s.url;
      return (c, p) => u(m, C, v, a)(c, i || p);
    },
    async adminMemberGrowthPointRecords(o, d, t, r, e) {
      var s, m;
      const l = await n.adminMemberGrowthPointRecords(o, d, t, r, e), i = (s = a == null ? void 0 : a.serverIndex) !== null && s !== void 0 ? s : 0, c = (m = b["MemberAdminApi.adminMemberGrowthPointRecords"]) === null || m === void 0 || (m = m[i]) === null || m === void 0 ? void 0 : m.url;
      return (p, S) => u(l, C, v, a)(p, c || S);
    },
    async adminMemberLevelOptions(o, d, t) {
      var r, e;
      const s = await n.adminMemberLevelOptions(o, d, t), m = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = b["MemberAdminApi.adminMemberLevelOptions"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => u(s, C, v, a)(i, l || c);
    },
    async adminMemberList(o, d, t) {
      var r, e;
      const s = await n.adminMemberList(o, d, t), m = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = b["MemberAdminApi.adminMemberList"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => u(s, C, v, a)(i, l || c);
    },
    async adminMemberMerge(o, d, t) {
      var r, e;
      const s = await n.adminMemberMerge(o, d, t), m = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, l = (e = b["MemberAdminApi.adminMemberMerge"]) === null || e === void 0 || (e = e[m]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => u(s, C, v, a)(i, l || c);
    },
    async adminMemberPointEvents(o, d, t, r, e, s, m, l, i) {
      var c, p;
      const S = await n.adminMemberPointEvents(o, d, t, r, e, s, m, l, i), U = (c = a == null ? void 0 : a.serverIndex) !== null && c !== void 0 ? c : 0, y = (p = b["MemberAdminApi.adminMemberPointEvents"]) === null || p === void 0 || (p = p[U]) === null || p === void 0 ? void 0 : p.url;
      return (L, R) => u(S, C, v, a)(L, y || R);
    },
    async adminMemberPointRecords(o, d, t, r, e, s, m, l, i) {
      var c, p;
      const S = await n.adminMemberPointRecords(o, d, t, r, e, s, m, l, i), U = (c = a == null ? void 0 : a.serverIndex) !== null && c !== void 0 ? c : 0, y = (p = b["MemberAdminApi.adminMemberPointRecords"]) === null || p === void 0 || (p = p[U]) === null || p === void 0 ? void 0 : p.url;
      return (L, R) => u(S, C, v, a)(L, y || R);
    },
    async adminMemberStats(o) {
      var d, t;
      const r = await n.adminMemberStats(o), e = (d = a == null ? void 0 : a.serverIndex) !== null && d !== void 0 ? d : 0, s = (t = b["MemberAdminApi.adminMemberStats"]) === null || t === void 0 || (t = t[e]) === null || t === void 0 ? void 0 : t.url;
      return (m, l) => u(r, C, v, a)(m, s || l);
    },
    async adminMemberUpdateLevel(o, d, t, r) {
      var e, s;
      const m = await n.adminMemberUpdateLevel(o, d, t, r), l = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, i = (s = b["MemberAdminApi.adminMemberUpdateLevel"]) === null || s === void 0 || (s = s[l]) === null || s === void 0 ? void 0 : s.url;
      return (c, p) => u(m, C, v, a)(c, i || p);
    },
    async adminMemberUpdateMember(o, d, t, r) {
      var e, s;
      const m = await n.adminMemberUpdateMember(o, d, t, r), l = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, i = (s = b["MemberAdminApi.adminMemberUpdateMember"]) === null || s === void 0 || (s = s[l]) === null || s === void 0 ? void 0 : s.url;
      return (c, p) => u(m, C, v, a)(c, i || p);
    },
    async adminMemberUpdateStatus(o, d, t, r) {
      var e, s;
      const m = await n.adminMemberUpdateStatus(o, d, t, r), l = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, i = (s = b["MemberAdminApi.adminMemberUpdateStatus"]) === null || s === void 0 || (s = s[l]) === null || s === void 0 ? void 0 : s.url;
      return (c, p) => u(m, C, v, a)(c, i || p);
    }
  };
}, E = function(a, n, o) {
  const d = h(a);
  return {
    adminControlledMemberImportConfirm(t, r) {
      return d.adminControlledMemberImportConfirm(t.importBatchId, t.memberImportConfirmRequest, r).then((e) => e(o, n));
    },
    adminControlledMemberImportErrors(t, r) {
      return d.adminControlledMemberImportErrors(t.importBatchId, r).then((e) => e(o, n));
    },
    adminControlledMemberImportGet(t, r) {
      return d.adminControlledMemberImportGet(t.importBatchId, r).then((e) => e(o, n));
    },
    adminControlledMemberImportList(t = {}, r) {
      return d.adminControlledMemberImportList(t.page, t.pageSize, r).then((e) => e(o, n));
    },
    adminControlledMemberImportPreview(t, r) {
      return d.adminControlledMemberImportPreview(t.controlledMemberImportPreviewRequest, r).then((e) => e(o, n));
    },
    adminControlledMemberImportSourceLevels(t, r) {
      return d.adminControlledMemberImportSourceLevels(t.sourceShopId, r).then((e) => e(o, n));
    },
    adminLegacyMemberImportCreateLegacyImportTask(t = {}, r) {
      return d.adminLegacyMemberImportCreateLegacyImportTask(t.dryRun, t.brandId, r).then((e) => e(o, n));
    },
    adminLegacyMemberImportGetLegacyImportTask(t, r) {
      return d.adminLegacyMemberImportGetLegacyImportTask(t.taskId, r).then((e) => e(o, n));
    },
    adminLegacyMemberImportLegacyImport(t = {}, r) {
      return d.adminLegacyMemberImportLegacyImport(t.dryRun, t.brandId, r).then((e) => e(o, n));
    },
    adminLegacyMemberImportLegacyImportTaskEvents(t, r) {
      return d.adminLegacyMemberImportLegacyImportTaskEvents(t.taskId, r).then((e) => e(o, n));
    },
    adminMemberAssets(t, r) {
      return d.adminMemberAssets(t.merchantCustomerUserId, t.shopId, r).then((e) => e(o, n));
    },
    adminMemberCashbackRecords(t, r) {
      return d.adminMemberCashbackRecords(t.merchantCustomerUserId, t.page, t.pageSize, t.shopId, r).then((e) => e(o, n));
    },
    adminMemberCreate(t, r) {
      return d.adminMemberCreate(t.adminMemberCreateRequestDTO, t.shopId, r).then((e) => e(o, n));
    },
    adminMemberDelete(t, r) {
      return d.adminMemberDelete(t.merchantCustomerUserId, t.shopId, r).then((e) => e(o, n));
    },
    adminMemberDetail(t, r) {
      return d.adminMemberDetail(t.merchantCustomerUserId, t.shopId, r).then((e) => e(o, n));
    },
    adminMemberDuplicates(t = {}, r) {
      return d.adminMemberDuplicates(t.page, t.pageSize, t.phone, r).then((e) => e(o, n));
    },
    adminMemberGrowthPointRecords(t, r) {
      return d.adminMemberGrowthPointRecords(t.merchantCustomerUserId, t.page, t.pageSize, t.shopId, r).then((e) => e(o, n));
    },
    adminMemberLevelOptions(t, r) {
      return d.adminMemberLevelOptions(t.merchantCustomerUserId, t.shopId, r).then((e) => e(o, n));
    },
    adminMemberList(t, r) {
      return d.adminMemberList(t.query, t.shopId, r).then((e) => e(o, n));
    },
    adminMemberMerge(t, r) {
      return d.adminMemberMerge(t.primaryId, t.memberMergeRequest, r).then((e) => e(o, n));
    },
    adminMemberPointEvents(t, r) {
      return d.adminMemberPointEvents(t.merchantCustomerUserId, t.page, t.pageSize, t.shopId, t.category, t.orderId, t.startAt, t.endAt, r).then((e) => e(o, n));
    },
    adminMemberPointRecords(t, r) {
      return d.adminMemberPointRecords(t.merchantCustomerUserId, t.page, t.pageSize, t.shopId, t.channel, t.transactionType, t.startAt, t.endAt, r).then((e) => e(o, n));
    },
    adminMemberStats(t) {
      return d.adminMemberStats(t).then((r) => r(o, n));
    },
    adminMemberUpdateLevel(t, r) {
      return d.adminMemberUpdateLevel(t.merchantCustomerUserId, t.adminMemberLevelUpdateRequestDTO, t.shopId, r).then((e) => e(o, n));
    },
    adminMemberUpdateMember(t, r) {
      return d.adminMemberUpdateMember(t.merchantCustomerUserId, t.adminMemberUpdateRequestDTO, t.shopId, r).then((e) => e(o, n));
    },
    adminMemberUpdateStatus(t, r) {
      return d.adminMemberUpdateStatus(t.merchantCustomerUserId, t.adminMemberStatusUpdateRequestDTO, t.shopId, r).then((e) => e(o, n));
    }
  };
}, _ = class extends x {
  adminControlledMemberImportConfirm(a, n) {
    return h(this.configuration).adminControlledMemberImportConfirm(a.importBatchId, a.memberImportConfirmRequest, n).then((o) => o(this.axios, this.basePath));
  }
  adminControlledMemberImportErrors(a, n) {
    return h(this.configuration).adminControlledMemberImportErrors(a.importBatchId, n).then((o) => o(this.axios, this.basePath));
  }
  adminControlledMemberImportGet(a, n) {
    return h(this.configuration).adminControlledMemberImportGet(a.importBatchId, n).then((o) => o(this.axios, this.basePath));
  }
  adminControlledMemberImportList(a = {}, n) {
    return h(this.configuration).adminControlledMemberImportList(a.page, a.pageSize, n).then((o) => o(this.axios, this.basePath));
  }
  adminControlledMemberImportPreview(a, n) {
    return h(this.configuration).adminControlledMemberImportPreview(a.controlledMemberImportPreviewRequest, n).then((o) => o(this.axios, this.basePath));
  }
  adminControlledMemberImportSourceLevels(a, n) {
    return h(this.configuration).adminControlledMemberImportSourceLevels(a.sourceShopId, n).then((o) => o(this.axios, this.basePath));
  }
  adminLegacyMemberImportCreateLegacyImportTask(a = {}, n) {
    return h(this.configuration).adminLegacyMemberImportCreateLegacyImportTask(a.dryRun, a.brandId, n).then((o) => o(this.axios, this.basePath));
  }
  adminLegacyMemberImportGetLegacyImportTask(a, n) {
    return h(this.configuration).adminLegacyMemberImportGetLegacyImportTask(a.taskId, n).then((o) => o(this.axios, this.basePath));
  }
  adminLegacyMemberImportLegacyImport(a = {}, n) {
    return h(this.configuration).adminLegacyMemberImportLegacyImport(a.dryRun, a.brandId, n).then((o) => o(this.axios, this.basePath));
  }
  adminLegacyMemberImportLegacyImportTaskEvents(a, n) {
    return h(this.configuration).adminLegacyMemberImportLegacyImportTaskEvents(a.taskId, n).then((o) => o(this.axios, this.basePath));
  }
  adminMemberAssets(a, n) {
    return h(this.configuration).adminMemberAssets(a.merchantCustomerUserId, a.shopId, n).then((o) => o(this.axios, this.basePath));
  }
  adminMemberCashbackRecords(a, n) {
    return h(this.configuration).adminMemberCashbackRecords(a.merchantCustomerUserId, a.page, a.pageSize, a.shopId, n).then((o) => o(this.axios, this.basePath));
  }
  adminMemberCreate(a, n) {
    return h(this.configuration).adminMemberCreate(a.adminMemberCreateRequestDTO, a.shopId, n).then((o) => o(this.axios, this.basePath));
  }
  adminMemberDelete(a, n) {
    return h(this.configuration).adminMemberDelete(a.merchantCustomerUserId, a.shopId, n).then((o) => o(this.axios, this.basePath));
  }
  adminMemberDetail(a, n) {
    return h(this.configuration).adminMemberDetail(a.merchantCustomerUserId, a.shopId, n).then((o) => o(this.axios, this.basePath));
  }
  adminMemberDuplicates(a = {}, n) {
    return h(this.configuration).adminMemberDuplicates(a.page, a.pageSize, a.phone, n).then((o) => o(this.axios, this.basePath));
  }
  adminMemberGrowthPointRecords(a, n) {
    return h(this.configuration).adminMemberGrowthPointRecords(a.merchantCustomerUserId, a.page, a.pageSize, a.shopId, n).then((o) => o(this.axios, this.basePath));
  }
  adminMemberLevelOptions(a, n) {
    return h(this.configuration).adminMemberLevelOptions(a.merchantCustomerUserId, a.shopId, n).then((o) => o(this.axios, this.basePath));
  }
  adminMemberList(a, n) {
    return h(this.configuration).adminMemberList(a.query, a.shopId, n).then((o) => o(this.axios, this.basePath));
  }
  adminMemberMerge(a, n) {
    return h(this.configuration).adminMemberMerge(a.primaryId, a.memberMergeRequest, n).then((o) => o(this.axios, this.basePath));
  }
  adminMemberPointEvents(a, n) {
    return h(this.configuration).adminMemberPointEvents(a.merchantCustomerUserId, a.page, a.pageSize, a.shopId, a.category, a.orderId, a.startAt, a.endAt, n).then((o) => o(this.axios, this.basePath));
  }
  adminMemberPointRecords(a, n) {
    return h(this.configuration).adminMemberPointRecords(a.merchantCustomerUserId, a.page, a.pageSize, a.shopId, a.channel, a.transactionType, a.startAt, a.endAt, n).then((o) => o(this.axios, this.basePath));
  }
  adminMemberStats(a) {
    return h(this.configuration).adminMemberStats(a).then((n) => n(this.axios, this.basePath));
  }
  adminMemberUpdateLevel(a, n) {
    return h(this.configuration).adminMemberUpdateLevel(a.merchantCustomerUserId, a.adminMemberLevelUpdateRequestDTO, a.shopId, n).then((o) => o(this.axios, this.basePath));
  }
  adminMemberUpdateMember(a, n) {
    return h(this.configuration).adminMemberUpdateMember(a.merchantCustomerUserId, a.adminMemberUpdateRequestDTO, a.shopId, n).then((o) => o(this.axios, this.basePath));
  }
  adminMemberUpdateStatus(a, n) {
    return h(this.configuration).adminMemberUpdateStatus(a.merchantCustomerUserId, a.adminMemberStatusUpdateRequestDTO, a.shopId, n).then((o) => o(this.axios, this.basePath));
  }
}, g = {
  Earn: "EARN",
  Use: "USE",
  Return: "RETURN",
  Adjust: "ADJUST",
  Processing: "PROCESSING"
};
export {
  g as AdminMemberPointEventsCategory,
  _ as MemberAdminApi,
  w as MemberAdminApiAxiosParamCreator,
  E as MemberAdminApiFactory,
  h as MemberAdminApiFp
};

//# sourceMappingURL=member-admin-api.js.map